// Load the `places` library alongside the core Maps JS API so the new
// AutocompleteSuggestion/Place classes are available on window.google.maps.places.
export const GOOGLE_MAPS_LIBRARIES: 'places'[] = ['places'];

export const DEBOUNCE_MS = 200;

// `route` is included so typing a street name like "Toledo Rd" surfaces matches
// before a house number is entered. `street_address` / `premise` / `subpremise`
// cover complete postal addresses, named buildings, and unit/apt numbers.
export const ADDRESS_INCLUDED_PRIMARY_TYPES: readonly string[] = ['street_address', 'premise', 'subpremise', 'route'];

// ISO-3166-1 alpha-2 region codes the autocomplete should restrict to. US-only
// is sufficient for every surface that currently renders AddressAutocomplete.
export const ADDRESS_INCLUDED_REGION_CODES: readonly string[] = ['US'];
